<template>
  <v-text-field
    v-model="input"
    :rules="requiredRule"
    type="number"
    :label="customField.label + (required ? ' *' : '')"
    :hint="customField.hint"
    :disabled="disabled"
    :loading="loading"
    :placeholder="customField.placeholder"
    outlined
    persistent-hint
  />
</template>

<style></style>

<script lang="ts">
import { Component } from "vue-property-decorator";
import CustomFieldText from "./CustomFieldText.vue";

@Component({
  components: {}
})
export default class CustomFieldNumber extends CustomFieldText {}
</script>
